module.exports = __webpack_public_path__ + "img/image.9ce6c02f.jpg";